import { render, staticRenderFns } from "./TheNavbarLeft.vue?vue&type=template&id=2e64cf20&scoped=true&"
import script from "./TheNavbarLeft.vue?vue&type=script&lang=js&"
export * from "./TheNavbarLeft.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbarLeft.vue?vue&type=style&index=0&id=2e64cf20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e64cf20",
  null
  
)

export default component.exports